// src/redux/SessionUrl/sessionUrlSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { checkSessionUrlAPI, submitSessionUrlAPI } from "./sessionUrlApi";

// POST /public/session-url/check
export const checkSessionUrl = createAsyncThunk(
  "sessionUrl/checkSessionUrl",
  async ({ company_session_id, email }, { rejectWithValue }) => {
    try {
      const response = await checkSessionUrlAPI({ company_session_id, email });
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to check session URL"
      );
    }
  }
);

// POST /public/session-url/submit
export const submitSessionUrl = createAsyncThunk(
  "sessionUrl/submitSessionUrl",
  async ({ company_session_id, name, email, phone, result_json }, { rejectWithValue }) => {
    try {
      const response = await submitSessionUrlAPI({
        company_session_id,
        name,
        email,
        phone,
        result_json,
      });
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to submit session result"
      );
    }
  }
);

// ---------- Initial State ----------
const initialState = {
  checkSessionUrl: { data: null, loading: false, error: null },
  submitSessionUrl: { data: null, loading: false, error: null },
};

// ---------- Slice ----------
const sessionUrlSlice = createSlice({
  name: "sessionUrl",
  initialState,
  reducers: {
    clearCheckSessionUrl: (state) => {
      state.checkSessionUrl.data = null;
      state.checkSessionUrl.error = null;
    },
    clearSubmitSessionUrl: (state) => {
      state.submitSessionUrl.data = null;
      state.submitSessionUrl.error = null;
    },
  },
  extraReducers: (builder) => {
    // ---------- Check Session URL ----------
    builder
      .addCase(checkSessionUrl.pending, (state) => {
        state.checkSessionUrl.loading = true;
        state.checkSessionUrl.error = null;
      })
      .addCase(checkSessionUrl.fulfilled, (state, action) => {
        state.checkSessionUrl.loading = false;
        state.checkSessionUrl.data = action.payload?.data || action.payload;
      })
      .addCase(checkSessionUrl.rejected, (state, action) => {
        state.checkSessionUrl.loading = false;
        state.checkSessionUrl.error = action.payload;
      });

    // ---------- Submit Session URL ----------
    builder
      .addCase(submitSessionUrl.pending, (state) => {
        state.submitSessionUrl.loading = true;
        state.submitSessionUrl.error = null;
      })
      .addCase(submitSessionUrl.fulfilled, (state, action) => {
        state.submitSessionUrl.loading = false;
        state.submitSessionUrl.data = action.payload?.data || action.payload;
      })
      .addCase(submitSessionUrl.rejected, (state, action) => {
        state.submitSessionUrl.loading = false;
        state.submitSessionUrl.error = action.payload;
      });
  },
});

export const { clearCheckSessionUrl, clearSubmitSessionUrl } =
  sessionUrlSlice.actions;

export default sessionUrlSlice.reducer;
